import { isRouteErrorResponse, Link, useRouteError } from "react-router-dom";

import { Button } from "@/client/components/ui/button";

/**
 * Route-level error boundary. Catches render/loader errors anywhere in the tree
 * and shows a recoverable message instead of a blank screen.
 */
export function RouteError() {
  const error = useRouteError();

  let title = "Something went wrong";
  let detail = "An unexpected error occurred. Please try again.";

  if (isRouteErrorResponse(error)) {
    title = `${error.status} ${error.statusText}`;
    detail = error.status === 404 ? "We couldn't find that page." : detail;
  } else if (error instanceof Error) {
    detail = error.message;
  }

  return (
    <main className="flex min-h-svh flex-col items-center justify-center gap-4 p-8 text-center">
      <div className="flex flex-col gap-1">
        <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
        <p className="text-muted-foreground max-w-md text-sm">{detail}</p>
      </div>
      <Button asChild>
        <Link to="/">Back to home</Link>
      </Button>
    </main>
  );
}
